const Supplier = {
    supplier: () => 'admin/supplier',
    supplierById: (id: string) => `admin/supplier/${id}`,
    supplierCount: () =>'admin/supplier/count',
}
export default Supplier